import moment from "moment";
import { parse, stringify } from "qs";

import { formatDateMixin } from "@/mixins";

export function fixDate(date: any) {
	let currentTz = date.includes("+") ? date.split("+")[1] : date.split("-")[1];
	currentTz = Number(currentTz.split(":")[0]);

	if (currentTz <= 14 && currentTz >= -14) {
		return date;
	}

	const dateTime = date.split("+")[0];
	let d = new Date(dateTime);
	d.setDate(d.getDate() - 1);

	let stillUtc = moment.utc(d).toDate();
	let local = moment(stillUtc)
		.local()
		.format();
	return local;
}

// Gets the timezone for the URL, if it does not exists.
export function getReportURLTimeZone(url: string, timeZone: string): string {
	if (!url.includes("&timeZone=")) {
		return `&timeZone=${timeZone}`;
	}
	return "";
}

export function createReportUrl(reportUrl: string, urlFiltered: any, relativeDaysToReport: number, timeZone: string, encodeDateTime: boolean = true) {
	// if timezone exists in the url then the filters have already been applied.
	if (!reportUrl.toLowerCase().includes("timezone")) {
		if (encodeDateTime) {
			urlFiltered.startDate = fixDate(urlFiltered.startDate);
			urlFiltered.endDate = fixDate(urlFiltered.endDate);

			urlFiltered.startDate = encodeURIComponent(urlFiltered.startDate);
			urlFiltered.endDate = encodeURIComponent(urlFiltered.endDate);
			urlFiltered.startTime = encodeURIComponent(urlFiltered.startTime);
			urlFiltered.endTime = encodeURIComponent(urlFiltered.endTime);
		}

		// Create the parameters to append to the reports URL
		if(reportUrl.includes("?")){
			reportUrl += (stringify(urlFiltered, { encode: false }) ? `&${stringify(urlFiltered, { encode: false })}` : "");
		}
		else {
			reportUrl += "?" + (stringify(urlFiltered, { encode: false }) ? `${stringify(urlFiltered, { encode: false })}` : "");
		}

		const timeZoneParameter = getReportURLTimeZone(reportUrl, timeZone);
		if (timeZoneParameter !== "") {
			reportUrl += timeZoneParameter;
		}

		// return the permalink variable so this report url
		return `${window.location.origin}${window.location.pathname}#/reports${reportUrl}&relativeDays=${relativeDaysToReport}`;
	}
	else {
		return `${window.location.origin}${window.location.pathname}#/reports${reportUrl}`;
	}

}

/**
 * Gets the decoded parameters of a url.
 * @param url  The URL to decode.
 */
export function decodeUrlParameters(url: string) {
	// Create an iterator containing all parameters (after the ?) from the url.
	var result = Object.fromEntries(
		new URLSearchParams(
			url.substr(url.indexOf("?"), url.length)
		).entries()
	);

	let toSentenceCase = function (str: string) {
		// Find and breakup camelCase by capital letters, convert all to lower case.
		var newString = str.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g).join(" ").toLowerCase();
		// Capitalise the first letter.
		newString = newString.charAt(0).toUpperCase() + newString.slice(1);
		return newString;
	}

	// Check if url is using advance dates
	let advanceDates: boolean = false;
	Object.keys(result).forEach(key => {
		if (key.search("days")) {
			advanceDates = true;
		}
	});

	// Fix up the key names using the toSentanceCase function above.
	Object.entries(result).forEach(([key, value]) => {
		if (key.toLowerCase() == "startdate" || key.toLowerCase() == "enddate" || key.toLowerCase() == "starttime" || key.toLowerCase() == "endtime") {
			// Skip end date and time
			if (key.toLowerCase() == "startdate" || key.toLowerCase() == "enddate") {
				result[toSentenceCase(key)] = parseDateTime(value);
			}
			else {
				delete result[key];
			}

		}
		else {
			result[toSentenceCase(key)] = value;	// Create a new key
			delete result[key];// Delete the old.
		}

	});

	return result;
}

/**
 * Formats the date to a more readable format.
 * @param item  the selected item from the table as a ReportHistoryData type.
 */
export function parseDateTime(item) : string  {
	return formatDateMixin.methods.displayDateFromISOString(item);
}
